/**
 * Cookie consent banner — PRD §7.5.
 * Renders at the bottom of the viewport until dismissed.
 * Sets localStorage key 'scope-cookies-accepted' = '1' on accept.
 * Dismissed state persists across sessions.
 */
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { routes } from '../routes.js';

const STORAGE_KEY = 'scope-cookies-accepted';

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Only show if not yet accepted
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  function handleAccept() {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      role="region"
      aria-label="Cookie consent"
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-scope-border-soft bg-white px-6 py-4 shadow-scope-lg"
    >
      <div className="mx-auto flex max-w-5xl flex-col gap-3 sm:flex-row sm:items-center sm:gap-6">
        <p className="flex-1 text-sm text-scope-text-muted">
          Scope uses a single authentication cookie, strictly necessary for the platform to
          function. No tracking or advertising cookies are used.{' '}
          <Link to={routes.privacy} className="text-scope-navy underline hover:no-underline">
            Privacy Policy
          </Link>
        </p>
        <div className="flex shrink-0 gap-3">
          <button
            onClick={handleAccept}
            className="rounded-lg bg-scope-navy px-4 py-2 text-sm font-medium text-white transition hover:bg-scope-navy/90 focus:outline-none focus:ring-2 focus:ring-scope-green"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
